import { useState } from 'react';

import { fetchPutSellerPayLink } from '@iwoca/lapi-client/edge';
import { Button } from '@iwoca/orion';
import classNames from 'classnames';

import styles from './ArchivedPayLinks.module.css';
import { LinkWithQuery } from '../../../components/LinkWithQuery/LinkWithQuery';
import { SellerNavBar } from '../../../components/NavBars/SellerNavBar/SellerNavBar';
import { PageTemplate } from '../../../components/PageTemplate/PageTemplate';
import { useStateKey } from '../../../hooks/useStateKey.hook';
import { Pagination } from '../components/Pagination/Pagination';
import { PayLinkTable } from '../components/PayLinkTable/PayLinkTable';
import { PaymentsSearch } from '../components/PayLinkTable/PaymentsSearch/PaymentsSearch';
import { usePayLinks } from '../hooks/usePaylinks.hook';

export const ArchivedPayLinks = () => {
  const { stateKey } = useStateKey();
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState<string>();
  const [checkedPayLinksIds, setCheckedPayLinksIds] = useState<string[]>([]);

  const {
    payLinks: archivedPayLinks,
    fetchPayLinks: fetchArchivedPayLinks,
    paginationLinks,
  } = usePayLinks({
    isArchived: true,
    searchQuery,
    page,
  });
  const { fetchPayLinks, totalCount: activePayLinksCount } = usePayLinks({
    isArchived: false,
    searchQuery,
  });

  const unarchivePayLinks = async (payLinkIds: string[]) => {
    const response = await fetchPutSellerPayLink({
      stateKey: stateKey!,
      body: {
        pay_link_ids: payLinkIds,
        is_archived: false,
      },
    });
    if (response.success) {
      setCheckedPayLinksIds([]);
    }
    await fetchPayLinks();
    await fetchArchivedPayLinks();
  };

  return (
    <PageTemplate NavBar={() => <SellerNavBar />}>
      <div className={styles.page}>
        <div className={styles.content}>
          <div className={styles.pageHeader}>Archived Payments</div>
          <div className={styles.paymentsActions}>
            <div className={styles.leftHandSide}>
              <Button
                variant="tertiary"
                className={classNames(
                  checkedPayLinksIds.length
                    ? styles.activeAction
                    : styles.inactiveAction,
                  styles.actionBarItem,
                )}
                onClick={() => unarchivePayLinks(checkedPayLinksIds)}
                disabled={!checkedPayLinksIds.length}
              >
                Unarchive
              </Button>
              <LinkWithQuery
                to="/pay/payments/"
                className={classNames(
                  styles.actionBarLink,
                  styles.actionBarItem,
                )}
              >
                Show Active ({activePayLinksCount ?? 0}) {'>'}
              </LinkWithQuery>
            </div>
            <div className={styles.rightHandSide}>
              <PaymentsSearch
                onChange={(query: string) => {
                  setSearchQuery(query);
                }}
              />
            </div>
          </div>
          <PayLinkTable
            payLinks={archivedPayLinks}
            checkedPayLinksIds={checkedPayLinksIds}
            setCheckedPayLinksIds={setCheckedPayLinksIds}
          />
        </div>
        <Pagination
          currentPageNumber={page}
          onPageSelect={(page?: number) => {
            if (!page) return;

            setPage(page);
          }}
          paginationLinks={paginationLinks}
        />
      </div>
    </PageTemplate>
  );
};
